import React from "react";
import { formatAmount } from "../../../utils/currencyFormatter";

/**
 * FarmerRealTimeBalanceCard - Displays farmer's current real-time balance
 * This is a prominent card showing the live balance from Firebase
 * Positioned at the top of the Farmer Payments page for quick visibility
 */

const FarmerRealTimeBalanceCard = ({ balance, loading }) => {
  if (loading) {
    return (
      <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-lg border-2 border-green-300 p-8 shadow-lg mb-6">
        <div className="text-center text-gray-600">Loading your current balance...</div>
      </div>
    );
  }

  const isPositive = balance >= 0;
  const balanceColor = isPositive ? "text-green-700" : "text-red-700";

  return (
    <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-lg border-2 border-green-300 p-8 shadow-lg mb-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-green-800 flex items-center gap-2">
            <span className="inline-block w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
            Your Current Balance
          </h3>
          <p className="text-sm text-green-700 mt-1">
            Real-time balance updated from all transactions
          </p>
        </div>
        <div className="text-xs text-green-600 bg-white/60 px-3 py-1 rounded-full">
          Live Data
        </div>
      </div>

      {/* Balance Display */}
      <div className="text-center py-6">
        <div className="text-5xl font-bold mb-2">
          <span className={balanceColor}>
            KES {formatAmount(balance)}
          </span>
        </div>
        <p className="text-sm text-gray-600">
          {isPositive 
            ? "Amount available in your account" 
            : "Amount owed to the company"}
        </p>
      </div>

      {/* Status Indicator */}
      <div className="flex items-center justify-center gap-4 mt-4">
        <div className="text-center">
          <div className="text-xs text-gray-600">Status</div>
          <div className={`text-sm font-semibold mt-1 ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {isPositive ? '✓ Positive Balance' : '⚠ Negative Balance'}
          </div>
        </div>
      </div>

      {/* Info Note */}
      <div className="mt-6 text-xs text-green-700 bg-white/60 p-3 rounded">
        💡 This is your current real-time balance. Use the monthly sections below to view detailed payment history and track changes over time.
      </div>
    </div>
  );
};

export default FarmerRealTimeBalanceCard;
